module.exports = __webpack_public_path__ + "static/media/not-allowed.1b1054d7.svg";